import React from 'react';

import Layout from './layout';
import { CommunityHead } from '~/components';
import Anchor from '~/components/Anchor';

const Page = () => (
  <>
    <CommunityHead title="认证服务协议" />
    <Layout>
      <h1>TiDB Community 认证服务协议</h1>
      <p>欢迎您加入 TiDB Community 并申请成为会员！</p>
      <p>
        TiDB Community
        认证服务（以下简称“本服务”）是北京平凯星辰科技发展有限公司（简称“平凯星辰”）提供给您的一项用户资质审核服务。由您发起申请，平凯星辰
        根据您的申请及其提交的资料和信息审核，并根据审核情况确定认证结果和认证信息的服务。
      </p>
      <p>
        为使用本服务，您应当阅读并遵守《TiDB Community 认证服务协议》（以下简称“本协议”）、
        <Anchor href={'https://www.pingcap.cn/terms-of-use'}>《平凯星辰使用条款》</Anchor>、
        <Anchor href={'https://www.pingcap.cn/privacy-policy'}>《平凯星辰隐私政策》</Anchor>以及相关规则、制度等。
      </p>
      <p>请注意本服务不提供给未满18周岁之人，如果您未满18周岁，请不要使用本服务。</p>

      <ol>
        <li>
          <h2>1. 协议的范围</h2>
          <p>
            本协议为<Anchor href={'https://www.pingcap.cn/terms-of-use'}>《平凯星辰使用条款》</Anchor>、
            <Anchor href={'https://www.pingcap.cn/privacy-policy'}>《平凯星辰隐私政策》</Anchor>
            的补充协议，本协议与前述内容冲突时，以本协议为准。
          </p>
        </li>

        <li>
          <h2>2. 您的权利义务</h2>
          <ol>
            <li>2.1 您可以根据自身需求，对您的 TiDB Community 账号发起认证审核申请。</li>
            <ol>
              <li>
                2.1.1 若您对您的 TiDB Community 账号发起认证审核申请，认证审核成功后，您有权享受认证权益，平凯星辰
                将不定期调整认证权益并于发布后生效。
              </li>
              <li>
                2.1.2 若您对您的 TiDB Community 账号发起认证审核申请，认证审核成功后，您的 TiDB Community
                账号将会展示认证标识。
              </li>
              <li>
                2.1.3 您使用认证权益时应遵守相关法规。否则，TiDB Community 及平凯星辰
                有权不经通知随时视行为情节对您的账号采取限制、停止使用认证权益等措施。
              </li>
            </ol>
            <li>
              2.2 您应保证提供给平凯星辰
              的所有资料和信息是真实、合法、准确的，不侵犯第三方合法权利。任何资料和信息的变更将可能影响认证结果，您应当在资料和信息变更时及时提出补充认证申请。
            </li>
            <li>
              2.3 您保证您有权将相关资料和信息提交给平凯星辰以按照本协议、
              <Anchor href={'https://www.pingcap.cn/terms-of-use'}>《平凯星辰使用条款》</Anchor>、
              <Anchor href={'https://www.pingcap.cn/privacy-policy'}>《平凯星辰隐私政策》</Anchor>
              等约定的方式加以使用。您保证该等行为不违反您与第三方之间的约定、您对第三方做出的承诺或其他您应遵守的规章、制度，并保证您的该等行为不会给平凯星辰招致第三方异议或纠纷。
            </li>
            <li>
              2.4 您同意并授权平凯星辰对您提交的资料和信息进行甄别核实，平凯星辰
              有权出于认证审核之必要查阅、使用及保存上述资料及信息，并有权与您就认证审核事宜进行联系。
            </li>
          </ol>
        </li>

        <li>
          <h2>3. TiDB Community 的权利义务</h2>
          <ol>
            <li>
              3.1 平凯星辰尊重并保护您的信息，平凯星辰
              将会采取合理的措施保护您所提交的一切资料及信息。除法律法规规定及本协议约定的情形外，未经您的许可，平凯星辰
              不会向其他第三方公开、透露上述资料及信息。在本协议许可的范围内，平凯星辰
              会对相关资料及信息采用专业加密存储与传输方式进行传输及使用，以保障您的信息安全。
            </li>
            <li>
              3.2 为保障 TiDB Community 认证服务的规范有序，平凯星辰
              有权针对用户的不同认证需求制定不同的认证审核标准及要求，并有权在必要时对相关标准及要求进行修改。
            </li>
            <li>
              3.3 平凯星辰有权根据用户提交的资料及信息判断、决定审核结果。平凯星辰
              根据审核结果开通相应的高级功能或高级权限的申请。
            </li>
          </ol>
        </li>

        <li>
          <h2>4. 认证服务规范</h2>
          <ol>
            <li>
              4.1 认证流程
              <p>
                您在完成在线申请及资料提交流程，平凯星辰会在3个工作日内展开认证审核工作，您应积极配合平凯星辰
                的审核需求，并有权随时了解、查询审核进度。
              </p>
            </li>
            <li>
              4.2 认证规则
              <ol>
                <li>
                  4.2.1 您理解并同意：TiDB Community
                  认证服务内容仅限于对您提交的资料及信息进行合理、谨慎的形式审查，但在平凯星辰
                  的合法权限和合理能力范围内，平凯星辰
                  无法实质审查您的实际经营、运营以及推广等行为，并不为此提供任何担保。
                </li>
                <li>
                  4.2.2 平凯星辰有权核实包括但不限于以下内容：
                  <ol>
                    <li>4.2.2.1 您所服务的公司或企业是否拥有合法主体资质；</li>
                    <li>4.2.2.2 账号主体身份，以及相关任职信息；</li>
                    <li>4.2.2.3 其他平凯星辰认为需要审核的内容。</li>
                  </ol>
                </li>
              </ol>
            </li>
          </ol>
        </li>

        <li>
          <h2>5. 知识产权</h2>
          <p>
            平凯星辰
            是本服务及其相关产品的知识产权权利人。本服务及其相关产品的一切著作权、商标权、专利权、商业秘密等知识产权，以及相关的所有信息内容（包括但不限于文字、图片、界面设计、版面框架等）均受中华人民共和国相关法律法规及相关国际条约的保护，由
            平凯星辰享有，本协议另行约定、或按照相关法律法规规定由其他权利人享有的除外。
          </p>
        </li>

        <li>
          <h2>6. 法律责任</h2>
          <ol>
            <li>
              6.1 如果平凯星辰发现或收到他人举报或投诉您违反本协议约定的，平凯星辰
              有权不经通知随时视行为情节对您的账号处以包括但不限于终止本服务资质审核、要求您补充资质审查资料、要求您修改认证信息、强制修改账号名称及认证信息直至取消认证等措施。
            </li>
            <li>
              6.2
              您理解并同意，因您违反本协议或相关服务条款的规定，导致第三方主张的任何索赔、要求或损失，您应当独立承担责任；平凯星辰
              因此遭受损失的，您也应当一并赔偿。
            </li>
          </ol>
        </li>

        <li>
          <h2>7. 其他</h2>
          <ol>
            <li>
              7.1 您使用本服务即视为您已阅读并同意受本协议的约束。平凯星辰
              有权在必要时修改本协议条款。您可以在相关服务页面查阅最新版本的条款。本协议条款变更后，如果您继续使用 TiDB
              Community 认证服务，即视为您已接受修改后的协议。如果您不接受修改后的协议，应当停止使用 TiDB Community
              认证服务。
            </li>
            <li>
              7.2
              本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）并由北京市海淀区人民法院专属管辖。
            </li>
          </ol>
        </li>
      </ol>

      <br />
      <div>北京平凯星辰科技发展有限公司</div>
      <div>2022年8月10日</div>
    </Layout>
  </>
);

export default Page;
